export const MuiListItemText = {
  root: { margin: [[4, 20, 4, 0]] },
}
